import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import SummaryApi from '../common';
import { authHeader } from '../helpers/auth-header';

const initialState = {
  products: [],
  categoryproducts: [],
  totalProductCount: 0,
  categoryProductCount: 0,
  loading: false,
  error: null
};

// Async thunk for fetching products with parameters
export const fetchProducts = createAsyncThunk(
  'product/fetchProducts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SummaryApi.allProduct.url}`, { params, headers: authHeader() });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchCategoryProducts = createAsyncThunk(
  'product/fetchCategoryProducts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SummaryApi.allProduct.url}`, { params, headers: authHeader() });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.user = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.listProducts.rows;
        state.totalProductCount = action.payload.listProducts.count;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCategoryProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryproducts = action.payload.listProducts;
        state.categoryProductCount = action.payload.count;
      })
      .addCase(fetchCategoryProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Action creators are generated for each case reducer function
export const { setUserDetails } = productSlice.actions

export default productSlice.reducer
